// extracted by mini-css-extract-plugin
export default {"headerBorder":"ActsKC2ListContainer_headerBorder__H7MyN"};